import { Typography } from "@mui/material";
import ReactSpeedometer, { Transition } from "react-d3-speedometer";

export default function SpeedoMeter({
  maxValue,
  minValue,
  value,
  isGradientColor,
  isGradientOpposite,
  isPercent,
  indicatorType,
  indicatorUnit,
  isTorqueModule,
  indicatorName,
  height,
}: any) {
  const getMeterColor = () => {
    const indicator = indicatorName?.split(" ");
    if (isTorqueModule) {
      switch (indicator[0]) {
        case "Torque":
        case "Power":
          return "#ffd966";
        case "Speed":
          return "#00000033";
        default:
          return "#FFA326";
      }
    }
    return "#FFA326";
  };

  const getTypographyColor = (type: string) => {
    switch (type) {
      case "warning":
        return "#E18442";
      case "error":
        return "#E21A00";
      default:
        return "#02B271";
    }
  };

  // Check if the indicator name is specifically "Drop in Efficiency" or "Propeller Unbalance"
  const isSpecialIndicator = ["drop in efficiency", "propeller unbalance"].includes(indicatorName?.toLowerCase());
  const isTwistAngleIndicator = indicatorName?.toLowerCase() === "twist angle";
  const numericValue = value === "Offline" ? 0 : Number(value);
  const valueSuffix = value === "Offline" ? "" : isTwistAngleIndicator ? "\u00B0" : isPercent ? "%" : "";

  return (
    <div>
      <ReactSpeedometer
        forceRender={true}
        maxValue={maxValue}
        minValue={minValue}
        height={height || 200}
        width={250}
        ringWidth={20}
        value={Number.isFinite(numericValue) ? numericValue : 0}
        needleTransition={"easeQuadIn" as Transition}
        needleTransitionDuration={0}
        needleColor={maxValue && "#434343"}
        needleHeightRatio={value === "Offline" ? 0 : 0.9}
        customSegmentStops={!isGradientColor ? [minValue, maxValue] : []}
        // Apply green-to-red gradient for "Drop in Efficiency" or "Propeller Unbalance"
        startColor={isSpecialIndicator ? "green" : isGradientOpposite ? "green" : "red"}
        segmentColors={
          !isGradientColor
            ? isSpecialIndicator
              ? ["green", "red"]  // Gradient from green to red if the indicator is one of the special ones
              : [getMeterColor(), getMeterColor()]  // Otherwise, use the default color
            : []
        }
        maxSegmentLabels={4}
        currentValueText={`${value}${valueSuffix ? ` ${valueSuffix}` : ""}`}
        segments={1000}
        // End color changes for green to red gradient, otherwise as per gradient opposite
        endColor={isSpecialIndicator ? "red" : isGradientOpposite ? "red" : "green"}
      />
      <Typography
        variant="body1"
        component={"p"}
        textAlign={"center"}
        sx={{
          color: getTypographyColor(indicatorType),
        }}
      >
        {indicatorUnit}
      </Typography>
    </div>
  );
}
